let onUnauthorized = null;
let loggingOut = false;

export function registerUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

export function notifyUnauthorized() {
  if (loggingOut || !onUnauthorized) {
    return;
  }
  loggingOut = true;
  Promise.resolve(onUnauthorized()).finally(() => {
    loggingOut = false;
  });
}
